// Pages
import RouterView from '@/components/pages/RouterView/Router'

import Moderator from '@/components/pages/Moderator/Moderator.vue'
import EditModerator from '@/components/pages/Moderator/ModeratorEdit.vue'

export default {
  path: '/raypro_moderators',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      redirect: '/users'
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: Moderator,
          props: true,
          name: 'view-moderator'
        },
        {
          path: 'edit',
          component: EditModerator,
          name: 'edit-moderator',
          props: true,
          meta: {breadcrumb: 'Edit'}
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/moderator.js